import Bulldozer5 from "../../assets/png/bulldozer5.png";
import VideoSchema from "../schema/VideoSchema";

const ExploreTUATARA = () => {
  return (
    <div>
      <VideoSchema
        title="Tuatara Company History & Utility Vehicle Overview"
        description="Learn about the history of Tuatara ATV, a company founded by Geoff Hill and Qingmei Pang in New Zealand. Discover the all-steel, heavy-duty utility vehicle built to endure agricultural & commercial challenges."
        thumbnailUrl="https://img.youtube.com/vi/OAkhAEYyw5g/maxresdefault.jpg"
        uploadDate="2023-01-01"
        duration="PT1M58S"
        contentUrl="https://www.youtube.com/embed/OAkhAEYyw5g"
        embedUrl="https://www.youtube.com/embed/OAkhAEYyw5g?si=wxmw_JI1NVLmQt5F"
      />
      <div className="md:pb-[122px] sm:pb-[80px] pb-[50px]">
        <div className="bg-[#fff] custom-container">
          <div className="">
            <div className="custom-container sm:pt-[63px] pt-[40px] flex w-[-webkit-fill-available] justify-start">
              <div className="flex w-[-webkit-fill-available] justify-end">
                <div className="max-w-[-webkit-fill-available]">
                  <div className="flex font-[Rockwell] 2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold ">
                    <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
                      EXPLORE
                      <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
                        {" "}
                        TUATARA
                      </span>
                    </span>
                  </div>
                  <h2 className="2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] text-[#000] text-[Roboto] font-bold py-[38px]">
                    COMPANY HISTORY
                  </h2>

                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="lg:col-span-2 col-span-1  font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                      The story of Tuatara began with a New Zealand native, Geoff Hill, and his wife Qingmei Pang, who
                      have over 15 years of experience in the vehicle manufacturing industry. From their home in New
                      Zealand, they recognized the need for a better utility vehicle—one that could handle demanding
                      tasks while remaining easy to operate and maintain. After more than six years of rigorous testing
                      and improvement, Geoff and Qingmei developed the first Tuatara model, which was released to the
                      public in 2017. Initially serving local farmers, Tuatara quickly attracted attention from
                      commercial industries and international buyers. This led to the creation of an innovative electric
                      model, which is now gaining significant market share.
                      <br />
                      <br />
                      Named after New Zealand's native tuatara—a remarkable reptile that has survived since the age of
                      dinosaurs and can live for over 100 years—Tuatara vehicles are built with the same resilience.
                      Engineered from solid steel, Tuatara vehicles are designed to evolve, endure, and thrive in
                      challenging terrains. Whether for commercial or recreational use, Tuatara is committed to creating
                      a sustainable and highly adaptable utility vehicle.
                      <br />
                      <br />
                      Today, Tuatara is a global brand, expanding into Europe, Australia, and the U.S. markets. Built
                      for both work and adventure, Tuatara is setting new standards for utility vehicles around the
                      world.
                    </div>
                    <div className="col-span-1 w-[-webkit-fill-available] sm:pt-[0px] pt-[40px]">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/OAkhAEYyw5g?si=wxmw_JI1NVLmQt5F"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ExploreTUATARA;
